export default {"src":"/_next/static/media/adobe.90f9ef84.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};